<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	import { postReq } from 'src/services/http';
	//Stores
	import { home_data } from 'src/stores/account/user';
import { auth_locked_devices } from 'src/stores/device-runtime/local-auth';
import { os, app } from 'src/stores/session/native-bridge';
	import { allDiscovered, ongoingDiscovery } from 'src/stores/features/discovered';
	// import { save_home } from 'src/helpers/home_helpers';
	//Design system components
	import { Alert, AlertV2, Text, ToggleV2, toast } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';
	import { init_discover_devices_android } from 'src/services/native_container_requests_android';
	import { init_discover_devices_ios } from 'src/services/native_container_requests_ios';
	import { save_home } from 'src/helpers/home_helpers';

	let checked =
		typeof $home_data?.globalLocalControl !== 'undefined'
			? $home_data?.globalLocalControl.useLocal
			: JSON.parse(localStorage.getItem('globalLocalControl'))?.useCloud || true;

	const save = async (nextChecked: boolean) => {
		checked = nextChecked;

		save_home('globalLocalControl', {
			useLocal: checked,
		});

		home_data.set({
			...$home_data,
			globalLocalControl: {
				useLocal: checked,
			},
		});

		if (checked) {
			toast.open({
				type: 'success',
				title: $format('toast_local_control_setting', {
					default: 'local control enabled',
				}),
			});
			if (!$app) {
				return;
			}
			if ($os === 'IOS') {
				init_discover_devices_ios();
			} else {
				init_discover_devices_android();
			}
			ongoingDiscovery.set(true);
			setTimeout(() => {
				ongoingDiscovery.set(false);
			}, 20000);
		} else {
			auth_locked_devices.set([]);
			toast.open({
				type: 'success',
				title: $format('toast_local_control_setting', {
					default: 'local control disabled',
				}),
			});
			allDiscovered.set({});
		}
	};
</script>

<div class="d-flex justify-content-between align-items-center gap-m mb-m">
	<div class="min-width-0">
		<Text styleType="body" class="mb-s">
			{capFirstChar($format('local_control', { default: 'Local Wi-Fi Network Control' }))}
		</Text>
		<Text styleType="body-small" class="text-color-muted">
			{$format('input_local_control_setting', {
				default: 'Use Local Network Control when available.',
			})}
		</Text>
	</div>

	<ToggleV2
		id="toggle-local-control"
		{checked}
		size="m"
		on:click={() => save(!checked)}
		aria-label={$format('local_control', { default: 'Local Wi-Fi Network Control' })}
	/>
</div>

<Alert
	class="mb-m"
	type="warning"
	isHeadingBold
	heading={capFirstChar(
		$format('alert_warning_generic_attention', {
			default: 'Attention!',
		}),
	)}
	message={capFirstChar(
		$format('alert_warning_message_local_control_setting', {
			default:
				'Disabling Local Network Control might improve the device communication and control for some Wi-Fi networks. On the other hand it is extremely unadvised to turn this off if you plan on using the devices without cloud connection.',
		}),
	)}
/>

<AlertV2
	heading={capFirstChar(
		$format('alert_info_local_control_setting', {
			default:
				'When turned off the app will control the Shelly devices in your account only via the cloud.',
		}),
	)}
/>
